export default __webpack_public_path__ + "static/media/authIllu.a33afef8.svg";